import { render, staticRenderFns } from "./specialisty.vue?vue&type=template&id=64044150&scoped=true&"
import script from "./specialisty.vue?vue&type=script&lang=js&"
export * from "./specialisty.vue?vue&type=script&lang=js&"
import style0 from "./specialisty.vue?vue&type=style&index=0&id=64044150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64044150",
  null
  
)

export default component.exports